/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import './content-group-cards';
import './content-group-cards-item';
import '../card/card-heading';
import '../content-group/content-group-copy';
import '../content-group/content-group-heading';
import '../cta/card-cta';
import '../cta/card-cta-footer';
